import React from "react";

function SubHeading({ text, className }) {
  return <p className={`font-bold text-2xl ${className} opacity-70`}>{text}</p>;
}

export default SubHeading;
